(function () {
  if (!matchMedia('(max-width: 749px)').matches) return;
  if (document.documentElement.getAttribute('data-ab-mpdp-emily') !== 'b') return;
    var STER = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.3l2.6 5.5 6 .7-4.4 4.1 1.2 5.9L10 14.6l-5.4 2.9 1.2-5.9L1.4 7.5l6-.7z"/></svg>';
  function sterren() {
    document.querySelectorAll('.product__info-container > .product__title').forEach(function (t) {
      var prev = t.previousElementSibling;
      if (prev && prev.classList.contains('ec-rating')) return;
      var el = document.createElement('div');
      el.className = 'ec-rating';
      el.innerHTML = '<span class="ec-rating__stars" aria-hidden="true">' + STER + STER + STER + STER + STER +
        '</span><span>4.7 / 5.0 \u2018Excellent\u2019 | 4879 reviews</span>';
      t.insertAdjacentElement('beforebegin', el);
    });
  }
    function bijnaOp() {
    document.querySelectorAll('.product__info-container > div > product-form').forEach(function (pf) {
      var blok = pf.parentElement;
      var prev = blok.previousElementSibling;
      if (prev && prev.classList.contains('ec-almost')) return;
      var el = document.createElement('p');
      el.className = 'ec-almost';
      el.innerHTML = '<span class="ec-almost__dot" aria-hidden="true"></span><span>Almost sold out</span>';
      blok.insertAdjacentElement('beforebegin', el);
    });
  }
    var AANKONDIGING = 'EARLY BLACK FRIDAY: UP TO 50% OFF';
  function aankondiging() {
    document.querySelectorAll('.emy-announce__msg').forEach(function (msg) {
      var doel = msg.querySelector('a') || msg;
      if (doel.textContent !== AANKONDIGING) doel.textContent = AANKONDIGING;
    });
  }
    var STER_KLEIN = STER;
  function vertrouwensBalk() {
    document.querySelectorAll('.emy-trustbar__text:not(.ec-trust)').forEach(function (p) {
      p.classList.add('ec-trust');
      p.innerHTML = '<span class="ec-trust__stars" aria-hidden="true">' + STER_KLEIN + STER_KLEIN + STER_KLEIN + STER_KLEIN + STER_KLEIN +
        '</span><span>105,000+ Happy Customers</span>';
    });
  }
    function bestseller() {
    document.querySelectorAll('.product__media-wrapper .emy-pbadge').forEach(function (b) {
      if (!b.classList.contains('ec-best')) b.classList.add('ec-best');
      if (b.textContent !== 'Bestseller') b.textContent = 'Bestseller';
    });
  }
    function prijsBadge() {
    document.querySelectorAll('.product__info-container .emy-save-pill').forEach(function (b) {
      if (!b.classList.contains('ec-ebf-pill')) b.classList.add('ec-ebf-pill');
      if (b.textContent !== 'EARLY BLACK FRIDAY!') b.textContent = 'EARLY BLACK FRIDAY!';
    });
  }
    function bolletjes() {
    document.querySelectorAll('.product__media-wrapper media-gallery').forEach(function (g) {
      var dots = g.querySelector('.emy-dots');
      var slider = g.querySelector('slider-component:not(.thumbnail-slider)');
      if (!dots || !slider) return;
      var onder = g.getBoundingClientRect().bottom - slider.getBoundingClientRect().bottom + 14;
      var waarde = Math.round(onder) + 'px';
      if (dots.style.bottom !== waarde) dots.style.bottom = waarde;
    });
  }
    function blackFridayVak() {
    document.querySelectorAll('.product__info-container > div > product-form').forEach(function (pf) {
      var blok = pf.parentElement;
      var next = blok.nextElementSibling;
      if (next && next.classList.contains('ec-ebf')) return;
      var el = document.createElement('div');
      el.className = 'ec-ebf';
      var tier = function (n, pct) { return '<span class="ec-ebf__tier">' + n + ' items <b>\u2212' + pct + '%</b></span>'; };
      el.innerHTML = '<span class="ec-ebf__pill">Early Black Friday</span>Buy more, save more: ' + tier(2, 10) +
        ' \u00b7 ' + tier(3, 15) + ' \u00b7 ' + tier(4, 20) + ' \u00b7 ' + tier('5+', 25) +
        '<span class="ec-ebf__note">The discount is applied automatically in your cart.</span>';
      blok.insertAdjacentElement('afterend', el);
    });
  }
    var ICOON = {
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M3 12.2V4a1 1 0 0 1 1-1h8.2a1 1 0 0 1 .7.3l8 8a1 1 0 0 1 0 1.4l-8.2 8.2a1 1 0 0 1-1.4 0l-8-8a1 1 0 0 1-.3-.7z"/><circle cx="8" cy="8" r="1.6"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h12v10H2zM14 9h4l3 3.5V16h-7z"/><circle cx="6" cy="17.5" r="1.8" fill="#f6f4ef"/><circle cx="17" cy="17.5" r="1.8" fill="#f6f4ef"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true"><path d="M12 2.5l8 3v6c0 4.7-3.3 8.6-8 10-4.7-1.4-8-5.3-8-10v-6z"/><path d="M8.5 12l2.4 2.4 4.6-4.8"/></svg>'
  };
  function blackFridayKaart() {
    var usps = document.querySelector('main [id$="__emy_usps"]');
    if (!usps) return;
    var prev = usps.previousElementSibling;
    if (prev && prev.classList.contains('ec-ebf-card')) return;
    var el = document.createElement('section');
    el.className = 'ec-ebf-card';
    el.innerHTML =
      '<img class="ec-ebf-card__img" src="' + (window.cxMobilePdp && window.cxMobilePdp.kaartBeeld) + '" alt="" loading="lazy">' +
      '<div class="ec-ebf-card__body">' +
        '<p class="ec-ebf-card__eyebrow">Early Black Friday</p>' +
        '<h2 class="ec-ebf-card__title">Up to 50% off our winter favorites</h2>' +
        '<p class="ec-ebf-card__text">Our Early Black Friday prices are live now, for a limited time only.</p>' +
        '<ul class="ec-ebf-card__list">' +
          '<li>' + ICOON.tag + 'Up to 50% off the whole collection</li>' +
          '<li>' + ICOON.truck + 'Free shipping on every order</li>' +
          '<li>' + ICOON.shield + '30-day money-back guarantee</li>' +
        '</ul>' +
      '</div>';
    usps.insertAdjacentElement('beforebegin', el);
  }
    var EXTRA_BETAAL = {
    afterpay: '<svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-afterpay"><title id="pi-afterpay">Afterpay</title>' +
      '<rect width="38" height="24" rx="3" fill="#b2fce4"/><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"/>' +
      '<text x="19" y="14.6" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-weight="700" font-size="7.4" letter-spacing="-.1" fill="#000">afterpay</text></svg>',
    paypal: '<svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title>' +
      '<rect width="38" height="24" rx="3" fill="#fff"/><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"/>' +
      '<text x="19" y="15" text-anchor="middle" font-family="Verdana, Arial, Helvetica, sans-serif" font-weight="700" font-style="italic" font-size="8.2" letter-spacing="-.2"><tspan fill="#003087">Pay</tspan><tspan fill="#009cde">Pal</tspan></text></svg>'
  };
  function extraBetaal() {
    document.querySelectorAll('.product__info-container > .emy-pay').forEach(function (ul) {
      ['afterpay', 'paypal'].forEach(function (k) {
        if (ul.querySelector('[aria-labelledby="pi-' + k + '"]')) return;
        var li = document.createElement('li');
        li.innerHTML = EXTRA_BETAAL[k];
        ul.appendChild(li);
      });
    });
  }
  function alles() { sterren(); bijnaOp(); aankondiging(); vertrouwensBalk(); bestseller(); prijsBadge(); bolletjes(); blackFridayVak(); blackFridayKaart(); extraBetaal(); }
  alles();
  new MutationObserver(alles).observe(document.body, { childList: true, subtree: true });
  addEventListener('resize', bolletjes);
  addEventListener('load', bolletjes);
})();
